import { findIndex } from 'lodash';

export const replaceItem = <T = any>(arr: Readonly<T[]>, index: number, item: T) => [
	...arr.slice(0, index),
	item,
	...arr.slice(index + 1)
];

export const findAndReplaceItem = <T = any>(arr: Readonly<T[]>, item: T, predicate: any) => {
	const index = findIndex(arr, predicate);
	return index === -1 ? [...arr] : replaceItem(arr, index, item);
};

export const findAndReplaceOrInsertItem = <T = any>(arr: Readonly<T[]>, item: T, predicate: any) => {
	const index = findIndex(arr, predicate);

	if (index === -1) {
		return [...arr, item];
	} else {
		return replaceItem(arr, index, item);
	}
};

export const removeItem = <T = any>(arr: Readonly<T[]>, index: number) => [
	...arr.slice(0, index),
	...arr.slice(index + 1)
];

export const findAndRemoveItem = <T = any>(arr: Readonly<T[]>, predicate: any) => {
	const index = findIndex(arr, predicate);
	return index === -1 ? [...arr] : removeItem(arr, index);
};

export const intersperse = <T = any, S = any>(arr: T[], separator: S) => {
	return arr.flatMap((item, index, array) => {
		const lastIndex = array.length - 1;
		return index === lastIndex ? [item] : [item, separator];
	});
};

export const rotateByOffset = <T = any>(arr: T[], offset: number) => {
	const length = arr.length;
	const cutoff = (length + offset) % length;
	const firstPart = arr.slice(cutoff, length);
	const secondPart = arr.slice(0, cutoff);
	return [...firstPart, ...secondPart];
};

export const insertAfter = <T = any>(arr: T[], afterWhatToInsert: T, whatToInsert: T) => {
	const index = arr.indexOf(afterWhatToInsert);
	arr.splice(index + 1, 0, whatToInsert);
};
